import { useMemo } from 'react';

import { useOrgIsSelfServe } from '@hcs/self-serve-info';
import { POSTHOG_ENABLED, POSTHOG_KEY } from '@hcs/webapps';

import { POSTHOG_PLAYWRIGHT_DISABLED_PARAM } from '../constants';

export const usePostHogEnabled = () => {
  const { data: isSelfServeOrg, isFetched } = useOrgIsSelfServe();

  return useMemo(() => {
    // Wait until org data has been fetched before making a determination
    if (!isFetched) return false;
    // We want to optionally disable posthog for snapshot or e2e testing
    const disablePostHog = localStorage.getItem(
      POSTHOG_PLAYWRIGHT_DISABLED_PARAM,
    );
    return (
      !!isSelfServeOrg && POSTHOG_ENABLED && !!POSTHOG_KEY && !disablePostHog
    );
  }, [isFetched, isSelfServeOrg]);
};
